define([
    'text!index2024-athomeandpro/component/page-content.html',
    // 'index2024-athome/common/api',
    'jquery',
    '../common/utils',
    'inView',
    'index2021/component/image-float2021',
    'index2021/component/image-slick',
    'css!index2024-athomeandpro/component/page-content.css',
], function(
    tpl,
    // Api,
    $,
    Utils,
    inView,
    ImageFloat,
    ImageSlick
){
    return {
        template: tpl,
        components: {
            ImageFloat:ImageFloat,
            ImageSlick:ImageSlick
        },
        data: function(){
            return {
                isZh: true,
                isPC: true,
                productImg: [
                    {img: '/s20480_1724735308_8784.jpg',link: '/project-info?id=5'},
                    {img: '/s20480_1724936028_9972.jpg',link: '/project-info?id=1'},
                    {img: '/s20480_1724735361_7850.jpg',link: '/project-info?id=2'},
                ],
                productImg2: [
                    {img: '/s20480_1724735381_9794.jpg',link: '/project-info?id=7'},
                    {img: '/s20480_1724735403_8472.jpg',link: '/project-info?id=112'},
                    {img: '/s20480_1724735426_8096.jpg',link: '/project-info?id=4'},
                ],
                atHomeList: [
                    {img: 's20480_1724731164_6420.jpg',name: 'No.50',link: '/athome-info?id=57'},
                    {img: 's20480_1724731279_4599.jpg',name: 'No.53',link: '/athome-info?id=62'},
                    {img: 's20480_1724731299_8452.jpg',name: 'No.57',link: '/athome-info?id=66'},
                    {img: 's20480_1724936495_1252.jpg',name: 'No.58',link: '/athome-info?id=67'}
                ]
            };
        },
        methods: {
            init: function(){
                var _this = this;
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                    // _this.fnjiIndex = _this.$i18n.messages.en.fnjiIndex;
                }else {
                    _this.isZh = true;
                    // _this.fnjiIndex = _this.$i18n.messages.zh.fnjiIndex;
                }
                if($(window).width()<=750){
                    _this.isPC = false;
                }else {
                    _this.isPC = true;
                }
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
            Utils.emitPageReady();

        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./index2024-athomeandpro/component/page-content.js
// module id = 370
// module chunks = 9